import React from "react";
import ReactDOM from "react-dom/client";
import { Provider } from "react-redux";
import { Auth } from "aws-amplify";
import { BrowserRouter } from "react-router-dom";
import { AWS_CONFIG } from "./aws_config";
import App from "./App";
import store from "./redux/store";

import "bootstrap/dist/css/bootstrap.min.css";
import "react-toastify/dist/ReactToastify.css";
import "./styles/main.scss";

Auth.configure(AWS_CONFIG);

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <Provider store={store}>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </Provider>
);
